import type { ReadingRecord, SpreadDefinition, UserPreferences } from '@lilith-arcana-os/domain';

import {
  lilithDexie,
  type AuditCacheRecord,
  type CardCacheRecord,
  type MemoryCacheRecord,
  type SettingsCacheRecord,
  type SpreadCacheRecord,
} from './dexie-db';

export const browserRepositories = {
  readings: {
    list: () => lilithDexie.readings_cache.orderBy('cachedAt').reverse().toArray(),
    save: (reading: ReadingRecord) =>
      lilithDexie.readings_cache.add({
        reading,
        cachedAt: new Date().toISOString(),
      }),
  },
  cards: {
    bulkPut: (cards: CardCacheRecord[]) => lilithDexie.cards_cache.bulkPut(cards),
    list: () => lilithDexie.cards_cache.toArray(),
  },
  spreads: {
    bulkPut: (spreads: SpreadDefinition[]) =>
      lilithDexie.spreads_cache.bulkPut(
        spreads.map<SpreadCacheRecord>((spread) => ({
          id: spread.id,
          spread,
          updatedAt: new Date().toISOString(),
        })),
      ),
    list: () => lilithDexie.spreads_cache.toArray(),
  },
  memory: {
    list: () => lilithDexie.memory_cache.toArray(),
    bulkPut: (entries: MemoryCacheRecord[]) => lilithDexie.memory_cache.bulkPut(entries),
  },
  settings: {
    get: (key: string) => lilithDexie.settings_cache.get(key),
    savePreferences: (preferences: UserPreferences): Promise<string> =>
      lilithDexie.settings_cache.put({
        key: 'preferences',
        value: preferences,
        updatedAt: new Date().toISOString(),
      } satisfies SettingsCacheRecord),
  },
  audit: {
    save: (record: AuditCacheRecord) => lilithDexie.audit_cache.put(record),
    list: () => lilithDexie.audit_cache.toArray(),
  },
};
